export default "__VITE_ASSET__BppGHIAP__"